/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdInputNumberProps } from './type';

export const inputNumberDefaultProps: TdInputNumberProps = {
  allowInputOverLimit: true,
  autoWidth: false,
  autofocus: false,
  decimalPlaces: undefined,
  disabled: undefined,
  largeNumber: false,
  max: Infinity,
  min: -Infinity,
  placeholder: undefined,
  readonly: undefined,
  readOnly: undefined,
  size: 'medium',
  status: 'default',
  step: 1,
  theme: 'row',
};
